/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField, ReferenceField } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import ListTitle from '../../components/ListTitle'
import Datagrid from '../../components/Datagrid/Datagrid'
import Filter from '../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)

export default function OrganizationSalaryStructureList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            // sort={{ field: 'description', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Organization Salary Structure" />
                <Datagrid {...props}>
                    <ReferenceField
                        source="organization_id"
                        reference="PY_OrganizationMasterTAB"
                    >
                        <TextField
                            label="Organization"
                            headerClassName={classes.myHeader}
                            source="description"
                        />
                    </ReferenceField>
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/PY_SalaryStructureTAB"
                        />
                    ) : (
                        <EditButton basePath="/PY_SalaryStructureTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

OrganizationSalaryStructureList.defaultProps = {
    quickSearch: false,
}
OrganizationSalaryStructureList.propTypes = {
    quickSearch: PropTypes.bool,
}
